// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__OdupZ","empty":"ModalGraph_empty__2FxWz"};